"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stringToBoolean = void 0;
function stringToBoolean(value, defaultValue) {
    if (defaultValue === void 0) { defaultValue = false; }
    if (typeof value === 'boolean') {
        // Inputs that are literal booleans return their value.
        return value;
    }
    else if (!value) {
        // Unset flags return default or `false`.
        return defaultValue || false;
    }
    else {
        return ['true', 't'].includes(value.toLowerCase());
    }
}
exports.stringToBoolean = stringToBoolean;
//# sourceMappingURL=index.js.map